import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    FormGroup,
    FormControlLabel,
    Checkbox
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }

});

const DeviceDataApiForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    const services=[
        {displayValue: `${translations['always'] || 'Always'}`, value: 'always'},
        {displayValue: `${translations['if_there_was_error'] || 'If there was error'}`, value: 'on_error'},
        {displayValue: `${translations['never'] || 'Never'}`, value: 'never'},
    ];

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['device_data_api_name'] || 'Device data API name'}
                                label={translations['device_data_api_name'] || 'Device data API name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl id="active_select" className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["active"] || "Active"}</InputLabel>
                                <Select
                                    name="Active"
                                    value={values.Active}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Active && touched.Active)}
                                    placeholder={translations["active"] || "Active"}
                                    label={translations["active"] || "Active"}
                                    margin={"dense"}
                                    fullWidth={true}
                                >
                                    <MenuItem value={true}>
                                        {translations['active'] || 'Active'}
                                    </MenuItem>
                                    <MenuItem value={false}>
                                        {translations['inactive'] || 'Inactive'}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl id="type_select" className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["type"] || "Type"}</InputLabel>
                                <Select
                                    name="Type"
                                    value={values.Type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Type && touched.Type)}
                                    placeholder={translations["type"] || "Type"}
                                    label={translations["type"] || "Type"}
                                    margin={"dense"}
                                    fullWidth={true}
                                >
                                    <MenuItem value={'checkesn'}>
                                        {translations['checkesn'] || 'CheckESN'}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel >{translations["recall_service"] || "Recall Service"}</InputLabel>
                                <Select
                                    name="RecallBehavior"
                                    label={translations["recall_service"] || "Recall service"}
                                    margin={"dense"}
                                    value={values.RecallBehavior || "on_error"}
                                    onChange={handleChange}
                                >
                                    {(services ? [...services] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {
                                values.Type === 'checkesn' && (
                                    <>
                                        <InputLabel shrink>{translations['select_checkesn_services'] || "Please select which services you wish to use"}</InputLabel>
                                        <FormGroup row>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.AppleFullData}
                                                        onChange={handleChange}
                                                        name="AppleFullData"
                                                        color="primary"
                                                        disabled={values.AppleSimlockOnly}
                                                    />
                                                }
                                                label={translations['apple_full_data'] || 'Apple Full Data (SIM Lock, Carrier, Find my iPhone)'}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.AppleSimlockOnly}
                                                        onChange={handleChange}
                                                        name="AppleSimlockOnly"
                                                        color="primary"
                                                        disabled={values.AppleFullData}

                                                    />
                                                }
                                                label={translations['apple_simlock_only'] || 'Apple SIM Lock only'}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.GsmaBlacklist}
                                                        onChange={handleChange}
                                                        name="GsmaBlacklist"
                                                        color="primary"
                                                    />
                                                }
                                                label={translations['gsma_blacklist'] || 'GSMA Blacklist check'}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.SamsungWorldwide}
                                                        onChange={handleChange}
                                                        name="SamsungWorldwide"
                                                        color="primary"
                                                    />
                                                }
                                                label={translations['samsung_worldwide_check'] || 'Samsung Worldwide check'}
                                            />
                                        </FormGroup>
                                    </>
                                )
                            }

                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(DeviceDataApiForm);
